<template>
  <div>
    <v-autocomplete
      hide-details
      v-if="readonly === false"
      outlined
      dense
      flat
      :readonly="!habilitar"
      v-model="select"
      :items="filtradas"
      item-text="descripcion_localidad"
      item-value="id_localidad"
      label="Localidad"
      persistent-hint
      return-object
      @change="$emit('input', select)"
    ></v-autocomplete>
    <v-text-field
      hide-details
      v-if="readonly && !ocultarLabel && !texto"
      dense
      flat
      label="Localidad"
      readonly
      outlined
      filled
      :value="select.descripcion_localidad"
    ></v-text-field>
    <div v-if="readonly && ocultarLabel && !texto">
      {{ select.descripcion_localidad }}
    </div>
    <h3 v-if="texto">Loc: {{ select.descripcion_localidad }}</h3>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Object,
    readonly: {
      type: Boolean,
      default: false,
    },
    texto: {
      type: Boolean,
      default: false,
    },
    ocultarLabel: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      select: {
        id_localidad: 0,
        descripcion_localidad: "",
        id_provincia: 0,
      },
    };
  },
  computed: {
    ...mapState("localidades", ["Lista"]),
    filtradas: function() {
      if (this.value) {
        if (this.value.codigo_postal) {
          const filt = this.Lista.filter(
            (x) => x.codigo_postal == this.value.codigo_postal
          );
          if (filt.length == 1) {
            this.select = filt[0];
            this.$emit("input", this.select);
          }
          return filt;
        }
      }
      return this.Lista;
    },
    habilitar: function() {
      return this.filtradas.length > 1;
    },
    label() {
      let ret = "";
      if (!this.ocultarLabel) {
        ret = "Localidad";
      }
      return ret;
    },
  },
  mounted() {
    let sel = this.filtradas.find(
      (x) => x.id_localidad == this.value.id_localidad
    );
    if (sel) {
      this.select = sel;
    }
  },
  watch: {
    value() {
      let sel = this.filtradas.find(
        (x) => x.id_localidad == this.value.id_localidad
      );
      if (sel) {
        this.select = sel;
      }
    },
  },
};
</script>

<style></style>
